import React from 'react';
import cardImage9 from '../../../assets/back/1000306701.jpg';
import cardImage10 from '../../../assets/back/1000307365.jpg';
import cardImage11 from '../../../assets/back/1000307367.jpg';
import cardImage12 from '../../../assets/back/1000307368.jpg';


export default function Index(){
    return(
        <div className="container">
            <div className="row flex my-5">

                
                <div className="col-12 col-sm-6 col-md-3 mb-3">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title text-center gravitas-one-regular text-checked">KICK</h5>
                            <img src={cardImage9} className="card-img-top" alt="..."/>
                            <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                            <button href="#" className="btn w-100 btn-primary background-checked">Go somewhere</button>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3 mb-5">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title text-center gravitas-one-regular text-checked">TEZ GAM</h5>
                            <img src={cardImage10} className="card-img-top" alt="..."/>
                            <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                            <button href="#" className="btn w-100 btn-primary background-checked">Go somewhere</button>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3 mb-5">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title text-center gravitas-one-regular text-checked">BOXER</h5>
                            <img src={cardImage11} className="card-img-top" alt="..."/>
                            <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                            <button href="#" className="btn w-100 btn-primary background-checked">Go somewhere</button>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3 mb-5">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title text-center gravitas-one-regular text-checked">SIGNAL</h5>
                            <img src={cardImage12} className="card-img-top" alt="..."/>
                            <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                            <button href="#" className="btn w-100 btn-primary background-checked">Go somewhere</button>
                        </div>
                    </div>
                </div>

            </div>
            
        </div>
    )
}